export enum ActionType {
    EVAL_LANDING__RELOAD = 'EVAL_LANDING__RELOAD',
    EVAL_LANDING__RELOAD_RESULT = 'EVAL_LANDING__RELOAD_RESULT',
    EVAL_LANDING__CHANGE_DATE_RANGE = 'EVAL_LANDING__CHANGE_DATE_RANGE',
    EVAL_LANDING__CHANGE_DATE_RANGE_RESULT = 'EVAL_LANDING__CHANGE_DATE_RANGE_RESULT',
    EVAL_LANDING__SORT_ROWS = 'EVAL_LANDING__SORT_ROWS',
    EVAL_LANDING__FILTER_ROWS = 'EVAL_LANDING__FILTER_ROWS',
    EVAL_LANDING__TOGGLE_GRID_SHOW_ALL = 'EVAL_LANDING__TOGGLE_GRID_SHOW_ALL',
    EVAL_LANDING__RESET_GRID = 'EVAL_LANDING__RESET_GRID',
}
